export interface Category {
  id: number;
  slug: string;
  url: string;
  image: string;
  icon: string;
  name: {
    en: string;
    fr: string;
    da: string;
    de: string;
  };
}

export const categories: Category[] = [
  {
    id: 1,
    slug: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20pair%20of%20white%20and%20sage%20green%20running%20sneakers%20floating%20at%20a%20slight%20angle%20over%20a%20soft%20mint%20green%20studio%20background%20with%20gentle%20shadow%20soft%20natural%20lighting%20clean%20minimal%20product%20photography&width=600&height=400&seq=cat-shoes-01&orientation=landscape&nocache=true",
    icon: "ri-footprint-line",
    name: { en: "Shoes", fr: "Chaussures", da: "Sko", de: "Schuhe" },
  },
  {
    id: 2,
    slug: "hoodies-sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20folded%20terracotta%20orange%20hoodie%20with%20the%20hood%20visible%20stacked%20neatly%20on%20a%20warm%20cream%20textured%20surface%20soft%20morning%20light%20minimal%20product%20photography&width=600&height=400&seq=cat-hoodies-02&orientation=landscape&nocache=true",
    icon: "ri-shirt-line",
    name: { en: "Hoodies / Sweaters", fr: "Hoodies / Pulls", da: "Hættetrøjer / Sweatere", de: "Hoodies / Pullover" },
  },
  {
    id: 3,
    slug: "t-shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20neatly%20folded%20blush%20pink%20cotton%20t%20shirt%20with%20subtle%20fabric%20texture%20on%20a%20light%20sand%20beige%20background%20soft%20diffused%20studio%20lighting%20clean%20minimal%20product%20photography&width=600&height=400&seq=cat-tshirts-03&orientation=landscape&nocache=true",
    icon: "ri-t-shirt-line",
    name: { en: "T-Shirts", fr: "T-Shirts", da: "T-shirts", de: "T-Shirts" },
  },
  {
    id: 4,
    slug: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20lightweight%20olive%20green%20bomber%20jacket%20on%20a%20wooden%20hanger%20against%20a%20warm%20oatmeal%20wall%20soft%20natural%20window%20light%20minimal%20editorial%20product%20photo&width=600&height=400&seq=cat-jackets-04&orientation=landscape&nocache=true",
    icon: "ri-t-shirt-2-line",
    name: { en: "Jackets", fr: "Vestes", da: "Jakker", de: "Jacken" },
  },
  {
    id: 5,
    slug: "pants-shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Folded%20casual%20khaki%20chino%20pants%20and%20denim%20shorts%20stacked%20on%20a%20light%20gray%20linen%20surface%20soft%20even%20lighting%20minimal%20flat%20lay%20product%20photography&width=600&height=400&seq=cat-pants-05&orientation=landscape&nocache=true",
    icon: "ri-t-shirt-2-line",
    name: { en: "Pants / Shorts", fr: "Pantalons / Shorts", da: "Bukser / Shorts", de: "Hosen / Shorts" },
  },
  {
    id: 6,
    slug: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20mustard%20yellow%20baseball%20cap%20and%20a%20charcoal%20gray%20beanie%20side%20by%20side%20on%20a%20warm%20off%20white%20background%20soft%20studio%20light%20clean%20minimal%20product%20photo&width=600&height=400&seq=cat-headwear-06&orientation=landscape&nocache=true",
    icon: "ri-vip-crown-line",
    name: { en: "Headwear", fr: "Couvre-chefs", da: "Hovedbeklædning", de: "Kopfbedeckung" },
  },
  {
    id: 7,
    slug: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20matching%20sage%20green%20sweatshirt%20and%20jogger%20set%20laid%20flat%20on%20a%20light%20peach%20background%20soft%20natural%20light%20minimal%20flat%20lay%20fashion%20photography&width=600&height=400&seq=cat-sets-07&orientation=landscape&nocache=true",
    icon: "ri-stack-line",
    name: { en: "Sets", fr: "Ensembles", da: "Sæt", de: "Sets" },
  },
  {
    id: 8,
    slug: "underwear-underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Neatly%20folded%20soft%20gray%20and%20white%20cotton%20underwear%20briefs%20on%20a%20pale%20warm%20beige%20background%20soft%20diffused%20light%20clean%20minimal%20product%20photography&width=600&height=400&seq=cat-underwear-08&orientation=landscape&nocache=true",
    icon: "ri-shape-2-line",
    name: { en: "Underwear / Underpants", fr: "Sous-vêtements / Caleçons", da: "Undertøj / Underbukser", de: "Unterwäsche / Unterhosen" },
  },
  {
    id: 9,
    slug: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20folded%20athletic%20jersey%20in%20soft%20coral%20with%20subtle%20mesh%20texture%20on%20a%20light%20cream%20background%20soft%20studio%20lighting%20clean%20minimal%20sportswear%20product%20photo&width=600&height=400&seq=cat-jersey-09&orientation=landscape&nocache=true",
    icon: "ri-t-shirt-line",
    name: { en: "Jersey", fr: "Maillots", da: "Trøjer", de: "Trikots" },
  },
  {
    id: 10,
    slug: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20minimalist%20leather%20watch%20and%20a%20thin%20gold%20bracelet%20arranged%20on%20a%20warm%20sand%20colored%20surface%20soft%20natural%20light%20clean%20elegant%20product%20photography&width=600&height=400&seq=cat-accessories-10&orientation=landscape&nocache=true",
    icon: "ri-vip-diamond-line",
    name: { en: "Accessories", fr: "Accessoires", da: "Tilbehør", de: "Zubehör" },
  },
  {
    id: 11,
    slug: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20caramel%20brown%20leather%20tote%20bag%20and%20a%20canvas%20backpack%20on%20a%20light%20sage%20green%20background%20soft%20studio%20light%20clean%20minimal%20product%20photo&width=600&height=400&seq=cat-bags-11&orientation=landscape&nocache=true",
    icon: "ri-briefcase-line",
    name: { en: "Bags", fr: "Sacs", da: "Tasker", de: "Taschen" },
  },
  {
    id: 12,
    slug: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20coiled%20tan%20leather%20belt%20with%20a%20brushed%20brass%20buckle%20on%20a%20warm%20ivory%20background%20soft%20even%20lighting%20clean%20minimal%20accessory%20product%20photo&width=600&height=400&seq=cat-belts-12&orientation=landscape&nocache=true",
    icon: "ri-loop-left-line",
    name: { en: "Belts", fr: "Ceintures", da: "Bælter", de: "Gürtel" },
  },
  {
    id: 13,
    slug: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=An%20amber%20glass%20perfume%20bottle%20with%20soft%20golden%20backlight%20on%20a%20warm%20peach%20gradient%20background%20elegant%20minimal%20fragrance%20product%20photography&width=600&height=400&seq=cat-perfumes-13&orientation=landscape&nocache=true",
    icon: "ri-drop-line",
    name: { en: "Perfumes", fr: "Parfums", da: "Parfumer", de: "Parfums" },
  },
  {
    id: 14,
    slug: "other-stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=A%20small%20curated%20arrangement%20of%20everyday%20lifestyle%20items%20a%20water%20bottle%20sunglasses%20and%20keychain%20on%20a%20light%20oat%20colored%20surface%20soft%20natural%20light%20minimal%20product%20photo&width=600&height=400&seq=cat-other-14&orientation=landscape&nocache=true",
    icon: "ri-gift-line",
    name: { en: "Other Stuff", fr: "Autres articles", da: "Andet", de: "Sonstiges" },
  },
];